import * as XLSX from "xlsx";
export function getDayWiseAmount(monthlyAmount,start,end)
{
    let s=new Date(start);
    let e=new Date(end);
    let days = 30;
    const sY = s.getFullYear();
    const sM = s.getMonth()+1;
    const sD = s.getDate();

    const eY = e.getFullYear();
    const eM = e.getMonth()+1;
    const eD = e.getDate();    
    if(sM==eM && (sM==1 || sM==3 || sM==5 || sM==7|| sM==8 || sM==10 || sM==12))
    {
        days=eD-sD+1;
        if(days>30) days=30;        
    }
    else if(sM==eM && sM==2)
    {
        days=eD-sD+1;
        if(days>=28) days=30;
    }
    else if(sM==eM && (sM==4 || sM==6 || sM==9 || sM==11))
    {
        days=eD-sD+1;
    }
    else
    {
        days=(e-s)/(1000*3600*24);
    }
    const perDay = monthlyAmount / 30;
    return days * perDay;
}

export const exportToExcel = (tblid,filename) =>
{
    const table = document.getElementById(tblid);
    const workbook = XLSX.utils.table_to_book(table, { sheet: filename });
    XLSX.writeFile(workbook, filename+".xlsx");
};

export const exportArrayToExcel = (arr,filename) =>
{
  const worksheet = XLSX.utils.json_to_sheet(arr);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, filename);
  XLSX.writeFile(workbook, filename+".xlsx");
};